import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ChangeLtdPlanDurationPayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: ChangeLtdPlanDurationPayload) =>
    $actions.billing.changeLtdPlanDuration(dispatch, payload),
  );
};
